<template>
  <myDialog  :isDialog="isDialog" 
  :title="isView ? '查看机构' : (isEdit ? '编辑机构' : '添加机构')" 
  :width="'1200px'" @handleClose="handleClose">
    <template slot="content">
      <el-form :model="formData" 
      :rules="rules" 
      ref="form" 
      label-width="180px">
        <!-- 机构名称 -->
        <el-form-item label="机构名称" prop="name" required>
          <el-input v-model="formData.name" placeholder="请输入机构名称" :disabled="isView"></el-input>
        </el-form-item>

        <!-- 联系地址 -->
        <el-form-item label="联系地址" prop="contactAddress">
          <el-input v-model="formData.contactAddress" placeholder="请输入联系地址" :disabled="isView"></el-input>
        </el-form-item>

        <!-- 联系电话 -->
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input 
            v-model="formData.contactPhone" 
            placeholder="请输入联系电话" 
            maxlength="11" 
            show-word-limit
            :disabled="isView"
            @input="handlePhoneInput"
          ></el-input>
        </el-form-item>

        <!-- 诚信等级 -->
        <el-form-item label="诚信等级" prop="integrityGradeCode">
          <el-select
            v-model="formData.integrityGradeCode"
            placeholder="请选择诚信等级"
            clearable
            :disabled="isView"
            style="width: 100%;"
            @change="handleIntegrityGradeChange"
          >
            <el-option
              v-for="item in integrityGradeOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 评估年份 -->
        <el-form-item label="评估年份" prop="assessYear">
          <el-date-picker
            v-model="formData.assessYear"
            type="year"
            placeholder="选择年份"
            format="yyyy"
            value-format="yyyy"
            :disabled="isView"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>

        <!-- 网络核验 -->
        <el-form-item label="网络核验" prop="networkVerificationCode">
          <el-select
            v-model="formData.networkVerificationCode"
            placeholder="请选择网络核验"
            clearable
            :disabled="isView"
            style="width: 100%;"
            @change="handleNetworkVerificationChange"
          >
            <el-option
              v-for="item in networkVerificationOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 核验年份 -->
        <el-form-item label="核验年份" prop="verificationYear">
          <el-date-picker
            v-model="formData.verificationYear"
            type="year"
            placeholder="选择年份"
            format="yyyy"
            value-format="yyyy"
            :disabled="isView"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>

        <!-- 督导检查 -->
        <el-form-item label="督导检查" prop="ifSupervisorExamine">
          <el-select
            v-model="formData.ifSupervisorExamine"
            placeholder="请选择是否督导检查"
            clearable
            :disabled="isView"
            style="width: 100%;"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <!-- 督导问题 -->
        <el-form-item label="督导问题" prop="supervisorQuestion">
          <el-input 
            v-model="formData.supervisorQuestion" 
            type="textarea" 
            :rows="3"
            placeholder="请输入督导问题" 
            :disabled="isView"
          ></el-input>
        </el-form-item>

        <!-- 安全检查 -->
        <el-form-item label="安全检查" prop="ifSafetyExamine">
          <el-select
            v-model="formData.ifSafetyExamine"
            placeholder="请选择是否安全检查"
            clearable
            :disabled="isView"
            style="width: 100%;"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <!-- 安全问题 -->
        <el-form-item label="安全问题" prop="safetyQuestion">
          <el-input 
            v-model="formData.safetyQuestion" 
            type="textarea" 
            :rows="3"
            placeholder="请输入安全问题" 
            :disabled="isView"
          ></el-input>
        </el-form-item>

        <!-- 许可证号 -->
        <el-form-item label="许可证号" prop="licenseNumber">
          <el-input v-model="formData.licenseNumber" placeholder="请输入许可证号" :disabled="isView"></el-input>
        </el-form-item>

        <!-- 许可证有效期 -->
        <el-form-item label="许可证有效期" prop="licenseValidDate">
          <el-date-picker
            v-model="licenseValidDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :disabled="isView"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>

        <!-- 培训项目和等级 -->
        <el-form-item label="培训项目和等级" prop="cultivateInstitutionTrainingItemList">
          <div class="training-item-list">
            <el-table :data="formData.cultivateInstitutionTrainingItemList" border style="width: 100%">
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column label="培训项目名称" min-width="200">
                <template slot-scope="scope">
                  <el-input
                    v-if="!isView"
                    v-model="scope.row.name"
                    placeholder="请输入培训项目名称"
                    size="small"
                  ></el-input>
                  <span v-else>{{ scope.row.name || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="培训项目等级" min-width="200">
                <template slot-scope="scope">
                  <el-input
                    v-if="!isView"
                    v-model="scope.row.level"
                    placeholder="请输入培训项目等级"
                    size="small"
                  ></el-input>
                  <span v-else>{{ scope.row.level || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center" v-if="!isView">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    @click="handleRemoveTrainingItem(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="!isView" style="margin-top: 10px;">
              <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAddTrainingItem">添加新行</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </template>
    <template slot="footer">
       <el-button v-if="!isView" type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
      <el-button @click="handleClose">{{ isView ? '关闭' : '取消' }}</el-button>
     
    </template>
  </myDialog>
</template>

<script>
import { addOrganization, editOrganization, getOrganizationDetail } from '@/api/training'
import { getListByDictType } from '@/api/sys/dictData'

export default {
  name: 'PolicyDialog',
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        name: '',
        contactAddress: '',
        contactPhone: '',
        integrityGradeCode: '',
        integrityGradeName: '',
        assessYear: '',
        networkVerificationCode: '',
        networkVerificationName: '',
        verificationYear: '',
        ifSupervisorExamine: null,
        supervisorQuestion: '',
        ifSafetyExamine: null,
        safetyQuestion: '',
        licenseNumber: '',
        licenseValidStart: '',
        licenseValidEnd: '',
        cultivateInstitutionTrainingItemList: []
      },
      licenseValidDateRange: [],
      integrityGradeOptions: [],
      networkVerificationOptions: [],
      loading: false,
      rules: {
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        contactPhone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    editData: {
      handler(newVal) {
        if (newVal && (this.isEdit || this.isView) && Object.keys(newVal).length > 0) {
          this.loadFormData(newVal)
        }
      },
      immediate: true,
      deep: true
    },
    isDialog(val) {
      if (!val) {
        this.resetForm()
      } else if (val && this.isEdit && this.editData.id) {
        // 编辑模式下，如果有ID，获取详情
        this.getDetail()
      }
    },
    licenseValidDateRange(val) {
      if (val && val.length === 2) {
        // 将日期格式拼接为 yyyy-MM-dd 00:00:00
        const formatDate = (dateStr) => {
          if (!dateStr) return ''
          // 如果已经有时间部分，提取日期部分
          const datePart = dateStr.split(' ')[0]
          // 确保日期格式正确，然后拼接时间
          return datePart + ' 00:00:00'
        }
        this.formData.licenseValidStart = formatDate(val[0])
        this.formData.licenseValidEnd = formatDate(val[1])
      } else {
        this.formData.licenseValidStart = ''
        this.formData.licenseValidEnd = ''
      }
    }
  },
  created() {
    this.loadDictData()
  },
  methods: {
    // 加载字典数据
    async loadDictData() {
      // 加载诚信等级
      try {
        const integrityRes = await getListByDictType('cultivate_institution_integrity_grade')
        if (integrityRes && integrityRes.code === 200 && integrityRes.data) {
          this.integrityGradeOptions = integrityRes.data
        }
      } catch (error) {
        console.error('加载诚信等级失败', error)
      }

      // 加载网络核验
      try {
        const networkRes = await getListByDictType('cultivate_institution_network_verification')
        if (networkRes && networkRes.code === 200 && networkRes.data) {
          this.networkVerificationOptions = networkRes.data
        }
      } catch (error) {
        console.error('加载网络核验失败', error)
      }
    },
    // 获取详情
    async getDetail() {
      if (!this.editData.id) return
      try {
        const res = await getOrganizationDetail(this.editData.id)
        if (res && res.code === 200 && res.data) {
          this.loadFormData(res.data)
        }
      } catch (error) {
        console.error('获取详情失败', error)
        this.$message.error('获取详情失败')
      }
    },
    // 加载表单数据
    loadFormData(data) {
      // 根据 integrityGradeCode 查找对应的 integrityGradeName
      let integrityGradeName = data.integrityGradeName || ''
      if (!integrityGradeName && data.integrityGradeCode) {
        const selectedOption = this.integrityGradeOptions.find(item => item.dictValue === data.integrityGradeCode)
        if (selectedOption) {
          integrityGradeName = selectedOption.dictLabel
        }
      }

      // 根据 networkVerificationCode 查找对应的 networkVerificationName
      let networkVerificationName = data.networkVerificationName || ''
      if (!networkVerificationName && data.networkVerificationCode) {
        const selectedOption = this.networkVerificationOptions.find(item => item.dictValue === data.networkVerificationCode)
        if (selectedOption) {
          networkVerificationName = selectedOption.dictLabel
        }
      }

      this.formData = {
        id: data.id,
        name: data.name || '',
        contactAddress: data.contactAddress || '',
        contactPhone: data.contactPhone || '',
        integrityGradeCode: data.integrityGradeCode || '',
        integrityGradeName: integrityGradeName,
        assessYear: data.assessYear || '',
        networkVerificationCode: data.networkVerificationCode || '',
        networkVerificationName: networkVerificationName,
        verificationYear: data.verificationYear || '',
        ifSupervisorExamine: data.ifSupervisorExamine !== undefined && data.ifSupervisorExamine !== null ? Number(data.ifSupervisorExamine) : null,
        supervisorQuestion: data.supervisorQuestion || '',
        ifSafetyExamine: data.ifSafetyExamine !== undefined && data.ifSafetyExamine !== null ? Number(data.ifSafetyExamine) : null,
        safetyQuestion: data.safetyQuestion || '',
        licenseNumber: data.licenseNumber || '',
        licenseValidStart: data.licenseValidStart || '',
        licenseValidEnd: data.licenseValidEnd || '',
        cultivateInstitutionTrainingItemList: data.cultivateInstitutionTrainingItemList && Array.isArray(data.cultivateInstitutionTrainingItemList) 
          ? data.cultivateInstitutionTrainingItemList.map(item => ({
              name: item.name || '',
              level: item.level || ''
            }))
          : []
      }

      // 设置许可证有效期范围
      if (this.formData.licenseValidStart && this.formData.licenseValidEnd) {
        // 从带时间的字符串中提取日期部分（yyyy-MM-dd）
        const extractDate = (dateTimeStr) => {
          if (!dateTimeStr) return ''
          // 如果包含空格，提取日期部分
          return dateTimeStr.split(' ')[0]
        }
        this.licenseValidDateRange = [
          extractDate(this.formData.licenseValidStart),
          extractDate(this.formData.licenseValidEnd)
        ]
      } else {
        this.licenseValidDateRange = []
      }
    },
    // 处理诚信等级选择变化
    handleIntegrityGradeChange(value) {
      if (value) {
        // 根据选择的 dictValue 找到对应的 dictLabel
        const selectedOption = this.integrityGradeOptions.find(item => item.dictValue === value)
        if (selectedOption) {
          this.formData.integrityGradeName = selectedOption.dictLabel
        }
      } else {
        // 清空时，同时清空 name
        this.formData.integrityGradeName = ''
      }
    },
    // 处理网络核验选择变化
    handleNetworkVerificationChange(value) {
      if (value) {
        // 根据选择的 dictValue 找到对应的 dictLabel
        const selectedOption = this.networkVerificationOptions.find(item => item.dictValue === value)
        if (selectedOption) {
          this.formData.networkVerificationName = selectedOption.dictLabel
        }
      } else {
        // 清空时，同时清空 name
        this.formData.networkVerificationName = ''
      }
    },
    // 处理手机号输入
    handlePhoneInput(value) {
      // 只允许输入数字
      this.formData.contactPhone = value.replace(/\D/g, '')
    },
    // 添加培训项目
    handleAddTrainingItem() {
      this.formData.cultivateInstitutionTrainingItemList.push({
        name: '',
        level: ''
      })
    },
    // 删除培训项目
    handleRemoveTrainingItem(index) {
      this.formData.cultivateInstitutionTrainingItemList.splice(index, 1)
    },
    // 提交
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          
          // 确保日期格式为 yyyy-MM-dd 00:00:00
          const formatDateWithTime = (dateStr) => {
            if (!dateStr) return ''
            // 如果已经有时间部分，直接返回
            if (dateStr.includes(' ')) {
              return dateStr
            }
            // 如果没有时间部分，拼接 00:00:00
            return dateStr + ' 00:00:00'
          }
          
          // 构建提交数据
          const submitData = {
            name: this.formData.name,
            contactAddress: this.formData.contactAddress,
            contactPhone: this.formData.contactPhone,
            integrityGradeCode: this.formData.integrityGradeCode,
            integrityGradeName: this.formData.integrityGradeName,
            assessYear: this.formData.assessYear,
            networkVerificationCode: this.formData.networkVerificationCode,
            networkVerificationName: this.formData.networkVerificationName,
            verificationYear: this.formData.verificationYear,
            ifSupervisorExamine: this.formData.ifSupervisorExamine,
            supervisorQuestion: this.formData.supervisorQuestion,
            ifSafetyExamine: this.formData.ifSafetyExamine,
            safetyQuestion: this.formData.safetyQuestion,
            licenseNumber: this.formData.licenseNumber,
            licenseValidStart: formatDateWithTime(this.formData.licenseValidStart),
            licenseValidEnd: formatDateWithTime(this.formData.licenseValidEnd),
            cultivateInstitutionTrainingItemList: this.formData.cultivateInstitutionTrainingItemList.filter(item => 
              item.name || item.level
            )
          }
          
          // 如果是编辑，需要传递 id
          if (this.isEdit && this.formData.id) {
            submitData.id = this.formData.id
          }

          const api = this.isEdit ? editOrganization : addOrganization
          api(submitData).then(res => {
            if (res && res.code === 200) {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          }).catch(err => {
            console.error('请求出错', err)
            this.$message.error('操作失败')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 关闭
    handleClose() {
      this.$emit('handleClose')
      this.resetForm()
    },
    // 重置表单
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.formData = {
        name: '',
        contactAddress: '',
        contactPhone: '',
        integrityGradeCode: '',
        integrityGradeName: '',
        assessYear: '',
        networkVerificationCode: '',
        networkVerificationName: '',
        verificationYear: '',
        ifSupervisorExamine: null,
        supervisorQuestion: '',
        ifSafetyExamine: null,
        safetyQuestion: '',
        licenseNumber: '',
        licenseValidStart: '',
        licenseValidEnd: '',
        cultivateInstitutionTrainingItemList: []
      }
      this.licenseValidDateRange = []
    }
  }
}
</script>

<style lang="scss" scoped>
.training-item-list {
  width: 100%;
  
  .el-table {
    margin-bottom: 10px;
  }
}

/deep/ .el-form-item__label {
  .el-form-item.is-required &::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }
}

/deep/ .el-form-item__label {
    color: #2A3347 !important;
    font-weight: 400;
    font-size: 16px;
}

/deep/ .el-dialog__header {
    background: #297DEE !important;
}

/deep/ .el-dialog__title {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 17px;
}

/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}
</style>
